import type { PublicTenant } from '@shared/contracts.ts';
import { addDays, isoWeekday, localDate } from '@shared/period.ts';

export interface DayOption {
  day: string;
  isOpen: boolean;
  note: string;
}

/** Calendar days from today (studio time) to the booking horizon, with open/closed flags. */
export function bookingDays(t: Pick<PublicTenant, 'timezone' | 'hours' | 'exceptions' | 'rules'>, now = new Date()): DayOption[] {
  const today = localDate(now, t.timezone);
  const openWeekdays = new Set(t.hours.map((h) => h.weekday));
  const exceptions = new Map(t.exceptions.map((e) => [e.day, e]));
  return Array.from({ length: Math.min(t.rules.horizon_days, 60) }, (_, i) => {
    const day = addDays(today, i);
    const ex = exceptions.get(day);
    if (ex) return { day, isOpen: !ex.closed, note: ex.note };
    return { day, isOpen: openWeekdays.has(isoWeekday(day)), note: '' };
  });
}
